










import {Component, Prop, Vue} from "vue-property-decorator";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import HpSubTitle from "@/components/infrastructures/atoms/text/HpSubTitle.vue";
import HpText from "@/components/infrastructures/atoms/text/HpText.vue";

/** 「パスワードは不要になりました」など、終了したログイン方式の案内。 */
@Component({
  components: {PrimaryBtn, HpSubTitle, HpText}
})
export default class PasswordRetiredNotice extends Vue {
  name = "PasswordRetiredNotice";

  @Prop({default: "パスワードは不要になりました"}) title!: string;
  @Prop({default: "これからは「メールでログイン」でログインできます。"}) message!: string;
  @Prop({default: true}) showLoginButton!: boolean;
}
